import { render } from "./privacyContent.vue?vue&type=template&id=681a3416"
import script from "./privacyContent.vue?vue&type=script&lang=js"
export * from "./privacyContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__